/**
 * Fires when click to link for copy URL to clipboard.
 * @param {Event} clickEvent
 */
function copyLink(clickEvent) {
  var input = document.createElement("input");
  input.style.opacity = "0";
  document.body.append(input);
  input.value = window.location.href;

  input.select();

  const htmlLink = clickEvent.target;
  const isSuccessful = document.execCommand("copy");
  if (isSuccessful) {
    htmlLink.textContent = "Copied!";
  } else {
    htmlLink.textContent = "Copy to clipboard is not supported";
  }

  input.remove();
}

function initSocialShareButtons() {
  const sharingButtons = [].slice.call(document.querySelectorAll('.social-button-list-js > .item'),0);
  sharingButtons.forEach(function(buttonItem) {
    buttonItem.addEventListener('click', function(event) {
      event.preventDefault();

      const social = this.dataset.social || null;
      const path = window.location.href;
      const title = encodeURIComponent(document.title);

      let url = '';
      switch (social) {
        case 'facebook':
          url = 'https://www.facebook.com/sharer.php';
          url += '?u=' + path;
          break;

        case 'linkedin':
          url = 'https://www.linkedin.com/shareArticle';
          url += '?mini=true';
          url += '&url=' + path;
          url += '&title=' + title;
          break;

        case 'twitter':
          url = 'https://twitter.com/intent/tweet';
          url += '?url=' + path;
          url += '&text=' + title;
          break;

        case 'reddit':
          url = 'https://reddit.com/submit';
          url += '?url=' + path;
          url += '&title=' + title;
          break;
      }

      window.open(url, '', 'toolbar=0,menubar=no,status=0,width=600,height=480');
    });
  });
}

const $openModalShare = document.querySelector(".open-modal.share-btn");
const $closeModalShare = document.querySelector(".close-modal-share-js");
const $modalShare = document.querySelector("#modal-share");

if ($openModalShare) {
  $openModalShare.addEventListener("click", function (e) {
    e.preventDefault();
    $modalShare.classList.add("modal-open");
  });
}

if ($closeModalShare) {
  $closeModalShare.addEventListener("click", function (e) {
    e.preventDefault();
    $modalShare.classList.remove("modal-open");
  });
}

// BEGIN for post navigation in sidebar
const navigationItems = document.querySelectorAll(".lwptoc_items > .lwptoc_itemWrap .lwptoc_item");

if (navigationItems.length > 1) {
  const lastH2ItemInPostNav = document.querySelector('.post-navigation .lwptoc_items>.lwptoc_itemWrap>.lwptoc_item:last-child');

  if (lastH2ItemInPostNav) {
    const lastH3ItemInPostNav = lastH2ItemInPostNav.querySelector('.post-navigation .lwptoc_item:last-child');
    if (lastH3ItemInPostNav) {
      lastH3ItemInPostNav.classList.add('last-post-navigation-item');
    } else {
      lastH2ItemInPostNav.classList.add('last-post-navigation-item');
    }
  }
  const postNavigationLine = document.querySelector('.post-navigation-line');
  if (postNavigationLine) {
    postNavigationLine.classList.remove('transparent-line');
  }
}

const calcDistance = 235;
const offsetTitle = 200; // in single.scss #text-post h2, h3
const titles = document.querySelectorAll("h2 span, h3 span");
// height of title h1 may be different
const offsetBottom = document.querySelector("#image-blog-post").offsetTop + calcDistance;

const hashPost = location.href.split("#")[1];
if (hashPost) {
  const currentActive = document.querySelector('.post-navigation a[href*="' + hashPost + '"]');
  if (currentActive) {
    currentActive.parentNode.classList.add('active');
  }
}

window.addEventListener("scroll", function() {
  if (navigationItems.length > 0 && titles.length > 0) {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    titles.forEach(function (title) {
      if (title.id && title.offsetTop + offsetBottom <= scrollTop - offsetTitle) {
        const { id } = title;

        if (id) {
          const activeItem = document.querySelector(".post-navigation .active");
          if (activeItem) {
            activeItem.classList.remove("active");
          }

          // add class active to current title
          const postNav = document.querySelector(`.post-navigation a[href*="${id}"]`).parentNode;
          if (postNav) {
            postNav.classList.add("active");
          }
        }
      }
    });
  }
});

initSocialShareButtons();

function insertSwipeBlockForMobile() {
  const tables = [].slice.call(document.querySelectorAll("table:not(.tablepress)"), 0);

  tables.forEach(function (table) {
    table.outerHTML = `
    <div class='table-wrapper'>
      <div class='swipe-block'>
        <div class='swipe-icon'></div>
        <div class='swipe-text'>Swipe left to see the full sheet</div>
      </div>
      ${table.outerHTML}
    </div>`;
  });
}

const copyLinkEl = document.querySelector('.copy-link-js');
if (copyLinkEl) {
  copyLinkEl.addEventListener('click', copyLink);
}

// block for correct work sticky right-sidebar without global rebuild layout
const article = document.querySelector('article.post');
let articleHeight = 0;
const rightSidebar = document.querySelector('.sidebar-right-js');

function setHeightToSidebar() {
  const isMoreThanTablet = window.innerWidth >= 1260;
  const heightArticleHasChanged = article.offsetHeight !== articleHeight;
  if (isMoreThanTablet && heightArticleHasChanged) {
    articleHeight = article.offsetHeight;

    if (rightSidebar) {
      // move potentially hard operation to requestAnimationFrame
      requestAnimationFrame(function() {
        rightSidebar.style.height = articleHeight + 'px';
      });
    }
  }
}

setHeightToSidebar();
window.addEventListener('resize', setHeightToSidebar);

const $dclBtn = document.querySelector("#dcl_comment_btn");
if ($dclBtn) {
  $dclBtn.addEventListener("click", function() {
    const dclHiddenDiv = document.querySelector("#dcl-hidden-div");
    dclHiddenDiv.style.borderTop = "0";
    dclHiddenDiv.style.borderBottom = "0";
    dclHiddenDiv.style.display = "block";
  });
}

const tags = [].slice.call(document.querySelectorAll("#more_post_tags"), 0);
if (tags.length) {
  tags.forEach(function(tag) {
    tag.style.display = "none";
  });
}

const $moreTagsBtn = document.querySelector("#more_post_tags_button");

if ($moreTagsBtn) {
  $moreTagsBtn.addEventListener("click", function(e) {
    e.preventDefault();
    const $this = e.target;

    $this.style.display = "none";
    const morePostTags = document.querySelector("#more_post_tags");
    morePostTags.style.display = "block";
  });
}

insertSwipeBlockForMobile();
